import imagesLoaded from 'imagesloaded'

export default function (el) {
  return new Promise(resolve => {
    imagesLoaded(el, { background: '.preload-bg-img' }, resolve)
    // instance.on('progress', (_, image) => console.log(`Image is ${image.isLoaded ? 'loaded' : 'broken'} for ${image.img.src}`))
  })
}
